import { useQueryTeamMembersWithRelationship } from '@/hooks/query/useQueryTeamMembersWithRelationship';
import useQueryUserTier from '@/hooks/query/useQueryUserTier';
import { useCombinedQueriesTeamGeneralInfo } from '@heidi/workspace/data';
import { isEmpty } from 'lodash-es';

export function useShowSessionReview() {
  const { isTeamAdmin, teamDetails } = useCombinedQueriesTeamGeneralInfo();
  const { isTogetherOrHigherTier } = useQueryUserTier();

  const { data: teamMemberWithRelationship } = useQueryTeamMembersWithRelationship(
    teamDetails?.team.id
  );

  const isSessionReviewListEmpty = isEmpty(
    teamMemberWithRelationship?.team_member_relations
  );

  // for pro or free team admins, show session review list
  if (!isTogetherOrHigherTier && isTeamAdmin) {
    return true;
  }

  // for pro plus and enterprise users, show session review list if it is not empty
  return !isSessionReviewListEmpty;
}
